const isPending = status =>
  typeof status === 'string' && status.trim().toUpperCase().replace(/_/g, ' ').replace(/\s+/g, ' ') === 'POR PAGAR'

export const canDeleteRemuneration = rows =>
  Array.isArray(rows) && rows.length > 0 && rows.every(row =>
    isPending(row?.status) && isPending(row?.statusPrevired)
  )
